import { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiDividerStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            fontSize: '0.875rem',
            borderColor: variables.colors.other.background.divideline,
            marginTop: 1,
            marginBottom: 1,
        },
    },
});

export default createMuiDividerStyles;
